import React from 'react';
import FooterTop from './FooterTop';
import FooterBottom from './FooterBottom';

const Footer: React.FC = () => {
  return (
    <footer className="relative overflow-hidden border-t border-indigo-400/20 bg-[#050816] text-slate-200">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_10%_0%,rgba(59,130,246,0.12),transparent_30%),radial-gradient(circle_at_90%_10%,rgba(99,102,241,0.1),transparent_28%)]" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-indigo-300/50 to-transparent" />
      <FooterTop />
      <FooterBottom />
    </footer>
  );
};

export default Footer;
